import { render, staticRenderFns } from "./OracleAgile.vue?vue&type=template&id=f70767d2&scoped=true"
import script from "./OracleAgile.vue?vue&type=script&lang=js"
export * from "./OracleAgile.vue?vue&type=script&lang=js"
import style0 from "./OracleAgile.vue?vue&type=style&index=0&id=f70767d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70767d2",
  null
  
)

export default component.exports